<template>
  <div>
    <div class="flex flex-wrap justify-between items-center">
      <h4>Holidays</h4>
      <vs-button @click="holidayModal = true">Add Holidays</vs-button>
    </div>
    <div class="table-responsive">
      <table class="light_blue_table w-full mt-4">
        <thead>
          <tr>
            <td>Holiday Name</td>
            <td>No of Days</td>
            <td>Holiday Start Date</td>
            <td>Holiday End Date</td>
            <td style="width: 50px"></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(holiday, index) in holidayLIst" :key="index">
            <td>{{ holiday.holiday_name }}</td>
            <td>{{ holiday.no_of_days }}</td>
            <td>{{ holiday.start_hour }}</td>
            <td>{{ holiday.end_hour }}</td>
            <td>
              <vs-dropdown>
                <vs-button
                  class="btn-drop"
                  type="flat"
                  icon="more_vert"
                ></vs-button>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="editEvent(holiday.id)">
                    Edit
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="showPopUp(holiday.id)">
                    Delete
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </td>
          </tr>
          <tr v-if="holidayLIst.length==0" class="text-center">
           <td colspan="5">No Holidays Found</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup"
      v-if="holidayModal"
      :class="{ show: holidayModal }"
    >
      <div class="cstm-modal medium fixed_medium">
        <div class="header">
          <h4>Add Holiday</h4>
          <button @click.stop="holidayModal = false" class="close-modal">
            &times;
          </button>
        </div>
        <form data-vv-scope="CalendarEvent">
          <div
            style="max-height: 240px; overflow: auto"
            class="vertical_scrollbar border_btm p-4"
          >
            <div class="mb-4">
              <label class="required">Holiday Name</label>
              <vs-input
                class="w-full"
                v-validate="'required'"
                v-model="holiday_name"
                data-vv-name="Holiday Name"
                placeholder="Enter holiday name"
              />
            </div>
            <div class="flex flex-wrap justify-between">
              <div class="w-1/2 pr-2">
                <label class="block required">Start Date</label>
                <div class="flatpickr_with_icon">
                  <flat-pickr
                    icon-pack="feather"
                    v-validate="'required'"
                    icon="icon-calendar"
                    icon-after
                    data-vv-name="holiday start"
                    v-model="schedule_start_date"
                    :config="{ dateFormat: 'Y-m-d' }"
                    class="w-full"
                    placeholder="Start Time"
                  />
                  <vs-icon icon-pack="feather" icon="icon-calendar" />
                </div>
                <div
                  v-if="errors.has('CalendarEvent.holiday start')"
                  style="color: red"
                  class="invalid-feedback"
                >
                  {{ errors.first("CalendarEvent.holiday start") }}
                </div>
              </div>
              <div class="w-1/2 pl-2">
                <label class="block w-1/2 required">End Date</label>
                <div class="flatpickr_with_icon">
                  <flat-pickr
                    class="w-full"
                    placeholder="End Time"
                    v-validate="'required'"
                    icon-pack="feather"
                    icon="icon-calendar"
                    icon-after
                    data-vv-name="holiday end"
                    :disabled="this.schedule_start_date == ''"
                    v-model="schedule_end_date"
                    :config="{
                      dateFormat: 'Y-m-d',
                      minDate: this.schedule_start_date,
                    }"
                  />
                  <vs-icon icon-pack="feather" icon="icon-calendar" />
                </div>

                <div
                  v-if="errors.has('CalendarEvent.holiday end')"
                  style="color: red"
                  class="invalid-feedback"
                >
                  {{ errors.first("CalendarEvent.holiday end") }}
                </div>
              </div>
            </div>
            <div v-if="this.schedule_end_date != ''">
              No of days: {{ noOfDays }}
            </div>
            <vs-divider />

            <vs-button class="block mx-auto" @click="saveEvent()"
              >Save</vs-button
            >
          </div>
        </form>
      </div>
    </div>
    <vs-popup
        classContent="popup-example"
        title="Please Confirm"
        :active.sync="showPopUpBool"
      >
        <h4>Are you sure to delete this holiday?</h4>
        <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
          <vs-button class="mr-2" @click="deleteEvent(holidayIndex)">Confirm</vs-button>
          <vs-button type="border" color="danger" @click="showPopUpBool = false"
            >Cancel</vs-button
          >
        </vs-row>
      </vs-popup>
  </div>
</template>

<script>
import moment from 'moment'

import {
  saveSchoolHolidayApi,
  schoolHolidays,
  deleteSchoolHolidayApi
} from '@/api/schedulerApi'

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

export default {
  created () {
    this.fetchHolidaysList()
  },
  data () {
    return {
      showPopUpBool: false,
      holidayIndex: null,
      holidayModal: false,
      holidayLIst: [],
      customer_id: this.$store.getters.customerId,
      user_id: JSON.parse(localStorage.getItem('userInfo')).id,
      edit_id: null,
      holiday_name: '',
      noOfDays: null,
      schedule_start_date: '',
      schedule_end_date: '',
      difnoOfDays: 0,
      editingObject: []
    }
  },
  components: {
    flatPickr
  },
  watch: {
    schedule_end_date () {
      const a = moment(this.schedule_end_date)
      const b = moment(this.schedule_start_date)
      const c = a.diff(b, 'days')
      this.noOfDays = c + 1
    },
    schedule_start_date () {
      if (this.schedule_end_date) {
        const a = moment(this.schedule_end_date)
        const b = moment(this.schedule_start_date)
        const c = a.diff(b, 'days')
        this.noOfDays = c + 1
      } else {
        this.noOfDays = 0
      }
    }
  },
  methods: {
    showPopUp (holidayIndex) {
      this.holidayIndex = holidayIndex
      this.showPopUpBool = true
    },
    async fetchHolidaysList () {
      const data = await schoolHolidays(this.customer_id)
      this.holidayLIst = data.data.data.school_holiday
      console.log(this.holidayLIst.length)
    },
    async editEvent (id) {
      try {
        const value = this.holidayLIst.find((ele) => ele.id === id)
        this.editingObject = { ...value }
        this.edit_id = this.editingObject.id
        this.holiday_name = this.editingObject.holiday_name
        this.noOfDays = this.editingObject.no_of_days
        this.schedule_start_date = new Date(this.editingObject.start_hour)
        this.schedule_end_date = new Date(this.editingObject.end_hour)
        this.holidayModal = true
      } catch (error) {
        this.showSuccessMessage('Error', error.data.message, 'danger')
      }
    },
    saveEvent () {
      this.$validator.validateAll('CalendarEvent').then((valid) => {
        if (valid) {
          const payload = [
            {
              customer_id: this.customer_id,
              user_id: this.user_id,
              id: this.edit_id,
              start_hour: this.schedule_start_date,
              end_hour: this.schedule_end_date,
              holiday_name: this.holiday_name,
              no_of_days: parseInt(this.noOfDays)
            }
          ]
          this.savingEvent(payload)
        } else {
          this.showSuccessMessage('Error', 'Validation is Required', 'danger')
        }
      })
    },
    async savingEvent (requestParameter) {
      try {
        const customer_id = this.$store.getters.customerId

        const payload = {
          updateField: {
            holidays: requestParameter
          }
        }

        await saveSchoolHolidayApi(customer_id, payload)
        this.fetchHolidaysList()
        this.showSuccessMessage(
          'Success',
          'Holiday Added Successfully',
          'success'
        )
        this.holidayModal = false
        this.schedule_start_date = ''
        this.schedule_end_date = ''
        this.noOfDays = ''
        this.holiday_name = ''
      } catch (error) {
        this.showSuccessMessage('Error', error.data.message, 'danger')
      }
    },
    async deleteEvent (id) {
      try {
        const payload = {
          holiday_id: id
        }
        await deleteSchoolHolidayApi(this.customer_id, payload)
        this.showPopUpBool = false
        const holidayIndex = this.holidayLIst.findIndex((event) => event.id == id)
        this.holidayLIst.splice(holidayIndex, 1)
        this.showSuccessMessage(
          'success',
          'Holiday deleted successfully',
          'success'
        )
        // this.fetchHolidaysList()
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>